import * as types from '../../lib/actionTypes.es6';

export function getAmlConfigsRequest(partner) {
  return { type: types.GET_AML_CONFIGS_REQUEST, payload: partner };
}
export function getAmlConfigsSuccess(configs) {
  return { type: types.GET_AML_CONFIGS_SUCCESS, payload: configs };
}
export function getAmlConfigsFail(error) {
  return { type: types.GET_AML_CONFIGS_FAIL, payload: error };
}

export function getAmlConfigRawRequest(partner, type) {
  return { type: types.GET_AML_CONFIG_RAW_REQUEST, payload: { partner, type } };
}
export function getAmlConfigRawSuccess(raw) {
  return { type: types.GET_AML_CONFIG_RAW_SUCCESS, payload: raw };
}
export function getAmlConfigRawFail(error) {
  return { type: types.GET_AML_CONFIG_RAW_FAIL, payload: error };
}
export function getAmlConfigRawReset() {
  return { type: types.GET_AML_CONFIG_RAW_RESET };
}

export function publishAmlConfigRequest(partner, type, rawYaml) {
  return { type: types.PUBLISH_AML_CONFIG_REQUEST, payload: { partner, type, rawYaml } };
}
export function publishAmlConfigSuccess(result) {
  return { type: types.PUBLISH_AML_CONFIG_SUCCESS, payload: result };
}
export function publishAmlConfigFail(error) {
  return { type: types.PUBLISH_AML_CONFIG_FAIL, payload: error };
}
export function publishAmlConfigReset() {
  return { type: types.PUBLISH_AML_CONFIG_RESET };
}

export function createAmlConfigRequest(partner, rawYaml) {
  return { type: types.CREATE_AML_CONFIG_REQUEST, payload: { partner, rawYaml } };
}
export function createAmlConfigSuccess(result) {
  return { type: types.CREATE_AML_CONFIG_SUCCESS, payload: result };
}
export function createAmlConfigFail(error) {
  return { type: types.CREATE_AML_CONFIG_FAIL, payload: error };
}
export function createAmlConfigReset() {
  return { type: types.CREATE_AML_CONFIG_RESET };
}
